/* eslint-disable no-unused-vars */
/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-09-09 20:01:43
 * @LastEditTime: 2019-09-17 11:07:06
 * @LastEditors: yingbin
 */
import request from '../utils/request'
import utils from '@/utils/utils';
import { Message } from 'element-ui';

class controlApi {
	//查询我的应用列表
	getApplicationList(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "app.querypage",
				url:'/app/querypage',
				data: {
					"userName": JSON.parse(utils.getCookie("USER_INFO")),
					"pageNo": self.page,
					"pageSize": self.pageSize,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//查询应用下的所有已申请的API列表
	getApplyapiinfos(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "api.getapplyapiinfos",
				url:'/api/getapplyapiinfos',
				data: {
					"appId": self.appId,
					"pageNo": self.pageNo,
					"pageSize": self.pageSize,
					"userId": self.userId,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
	//新建应用
	createApp(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "app.createapp",
				url:'/app/createapp',
				data: {
					"userId": self.userId,
					"appId": self.appId,
					"appName": self.ruleForm.name,
					"appType": self.ruleForm.type,
					"appDesc": self.ruleForm.description,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else if (res.code == 40010) {
					self.$router.push({
						path: '/account/company'
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//获取应用基本信息
	getappInfo(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "app.getappinfo",
				url:'/app/getappinfo',
				data: {
					"userId": self.userId,
					"appId": self.appId,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//获取所有未被该应用申请过的API接口列表
	getApiinfos(self, appId) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "api.getapiinfos",
				url:"/api/getapiinfos",
				data: {
					"appId": self.appId,
					"pageNo": self.pageNo,
					"pageSize": self.pageSize,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//APP应用申请绑定API接口
	applyApis(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "api.applyapis",
				url:'/api/applyapis',
				data: {
					"userId": self.userId,
					"appId": self.appId,
					"apiNameList": self.apiNameList,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
	//应用下新增关联API菜单导航(左侧)
	menuList(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "api.menulist",
				url:"/api/menulist",
				data: {
					"appId": self.appId,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
	//应用下新增关联API关键字搜索
	keySearch(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "api.keysearch",
				url:'/api/keysearch',
				data: {
					"appId": self.appId,
					"apiName": self.keyWords,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//我的APP应用下API接口单次删除
	unbindApi(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "api.unbindapi",
				url:'/api/unbindapi',
				data: {
					"userId": self.userId,
					"appId": self.appId,
					"apiName": self.apiName,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//我的APP应用提交审核
	audit(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "app.audit",
				url:"/app/audit",
				data: {
					"appId": self.appId,
					"userId": self.userId,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//服务api接口调用日志查询
	getLoginfos(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "log.getloginfos",
				url:'/log/getloginfos',
				data: {
					"userId": self.userId,
					"token": utils.getCookie("TOKEN"),
					"beginTime": self.beginTime,
					"endTime": self.endTime,
					"orderNo": self.orderNo,
					"logType": self.logType,
					"pageNo": self.currentPage,
					"pageSize": self.pageSize,

				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//回推接口用户URL参数列表
	getapiconfigs(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "msgpush.apiconfigs",
				url:'/msgpush/apiconfigs',
				data: {
					token:utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				}else if(parseInt(res.code/10000) === 2){ //登录失效
					utils.removeCookie("USER_INFO");
					self.$store.commit("USER_INFO", '');
					self.$toast(true);  //跳出登录弹窗	
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	//用户修改回推接口地址
	getupdateurl(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "msgpush.updateurl",
				url:'/msgpush/updateurl',
				data: {
					token:utils.getCookie("TOKEN"),
					apiCode: self.addressObj.apiCode, //接口编码
					prodUrl: self.addressObj.prodUrl  //正式地址
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				}else {
					Message.error(res.message)
				}
			})
		})
	}

	//回推接口下的测试用例列表
	getapicases(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "msgpush.apicases",
				url:'/msgpush/apicases',
				data: {
					token:utils.getCookie("TOKEN"),
					apiCode: self.apiCode, //接口编码
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	//执行下发 接口联调测试（固定json格式，utf-8编码）
	getexcute(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "msgpush.excute",
				url:'/msgpush/excute',
				data: {
					token:utils.getCookie("TOKEN"),
					caseId:self.caseId, //接口用例ID
					uatUrl:self.uatUrl //测试地址
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					reject({
						success: false,
						data: res
					})
				}
			})
		})
	}

	//查看所有的API列表
	getmockapi(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "mockapi.apis",
				url:'/mockapi/apis',
				data: {
					token:utils.getCookie("TOKEN")
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	//生成签名
	generatesign(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "mockapi.generatesign",
				url:'/mockapi/generatesign',
				data: {
					token:utils.getCookie("TOKEN"),
					apiCode:self.apiCode,
					appKey:self.appKey,
					appSecret:self.appSecret,
					mockReq:self.mockReq
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}
}
export default new controlApi()